export default {"src":"/_booking/_next/static/media/menu-mobile-open-icon.e39f2cf8.svg","height":20,"width":30,"blurWidth":0,"blurHeight":0};